@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.settings-description {
  margin-bottom: 40px;
}

.rule-wrapper,
.additional-info {
  display: grid;
  grid-template-columns: 100px auto;
  margin: 10px 50px 10px 0;
}

.additional-info {
  margin-top: 40px;
  text-align: center;
}

.head-or-item {
  display: grid;
  grid-template-columns: auto 200px 100px;
  width: 100%;
  > div {
    text-align: center;
    padding: 10px 0;
  }
  &.item {
    border: 1px solid @settings-page--inventory-allocation--border-color;
    border-radius: 4px;
    box-shadow: 1px 1px 3px @settings-page--inventory-allocation--box-shadow-color;
    .task {
      border-right: 1px solid @settings-page--inventory-allocation--border-color;
      display: grid;
      grid-template-columns: 30px auto;
      align-items: center;
    }
    .prioritize {
      display: grid;
      place-content: center center;
      border-right: 1px solid @settings-page--inventory-allocation--border-color;
    }
  }
}

.locked {
  color: @settings-page--inventory-allocation--text-color;
}

.ordering-indicator {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
  cursor: initial;
}

.rule-grabber {
  display: flex;
  align-items: center;
  width: 24px;
  > svg {
    transform: scale(0.5);
    fill: @settings-page--inventory-allocation-rule-grabber--icon-color;
  }
}

.rule-actions {
  display: flex;
  flex-direction: column;
  align-self: center;
  text-align: center;
}

.pill {
  margin: 0 5px;
}

.tag-name {
  font-weight: 500;
}

.add-rule-wrapper {
  padding: 10px;
  border: 1px dashed @settings-page--inventory-allocation--border-color;
  border-radius: 4px;
  height: 100%;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
}

.add-rule-button {
  color: @settings-page--inventory-allocation--text-color;
  height: 100%;
  width: 100%;
  > div {
    display: flex;
  }
  &:focus {
    box-shadow: none;
  }
  &:hover {
    cursor: pointer;
  }
}

.add-rule-icon {
  height: 18px;
  width: 18px;
  fill: @settings-page--inventory-allocation-add-rule--icon-color;
  margin-right: 10px;
}

.loading-indicator {
  padding: 10px;
  > div {
    top: 100px;
  }
}

.allocation-strategy-errors {
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon-wrap {
    margin-right: 5px;
    > svg {
      height: 18px;
      width: 18px;
      fill: @settings-page--inventory-allocation-error--fill-color;
    }
  }
}

.help-article {
  font-weight: 700;
  color: @settings-page--inventory-allocation--link-color;
}
